import {
    getFirestore,
    collection,
    doc,
    query,
    where,
    orderBy,
    startAfter,
    limit,
    getDoc,
    getDocs,
    updateDoc,
    addDoc,
} from "firebase/firestore";

import { db } from "../apis/auth";

const dimScheduleCollection = "dim_sch_history";

export async function getDimScheduleHistory() {
    console.log(`===> ${dimScheduleCollection}-Query : getDimSchedule()`);
    const docRef = collection(db(), dimScheduleCollection);
    const docSnap = await getDocs(docRef);
    if (docSnap.exists()) {
        const record = docSnap.data();
        return Promise.resolve(record);

    }
    return Promise.reject("Unable to get dim schedule");
}

export async function createDimScheduleHistory(dimScheduleHistoryData) {
    const docRef = collection(db(), dimScheduleCollection);
    const docSnap = await addDoc(docRef, dimScheduleHistoryData);
    console.log(`${JSON.stringify(docSnap)}`);
    // if (docSnap.exists()) {
    return Promise.resolve();
    // }
    // return Promise.reject("Unable to update dim schedule"); 
}
export async function addDimSchHisWhenEnableStateChange(dimScheduleHistoryData) {
    const docRef = collection(db(), dimScheduleCollection);
    const docSnap = await addDoc(docRef, dimScheduleHistoryData);
    console.log(`${JSON.stringify(docSnap)}`);
    // if (docSnap.exists()) {
    return Promise.resolve();
    // }
    // return Promise.reject("Unable to update dim schedule"); 
}